import {ofType} from "redux-observable";
import {actions} from './redux.login'
import {filter, map, mapTo, delay} from 'rxjs/operators';

export const loginEpic = action$ => action$.pipe(
    ofType(actions.login),
    delay(1000),
    mapTo({type: 'PONG'})
);
